module.exports = __webpack_public_path__ + "static/media/Shikha.dd87ddb7.jpg";